"use client";

import { useEffect, useRef, useState } from "react";
import { TrendingUp, Users, Award } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AnimatedStats() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section ref={ref} className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <StatCard icon={<TrendingUp className="h-12 w-12 text-primary" />} endValue={250} label="Properties Sold" isVisible={isVisible} delay={0} />
          <StatCard icon={<Users className="h-12 w-12 text-primary" />} endValue={1200} label="Happy Clients" isVisible={isVisible} delay={100} />
          <StatCard icon={<Award className="h-12 w-12 text-primary" />} endValue={98} label="Success Rate %" isVisible={isVisible} delay={200} />
        </div>
      </div>
    </section>;
}
interface StatCardProps {
  icon: React.ReactNode;
  endValue: number;
  label: string;
  isVisible: boolean;
  delay: number;
}
function StatCard({
  icon,
  endValue,
  label,
  isVisible,
  delay
}: StatCardProps) {
  const [count, setCount] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const iconRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!isVisible || hasAnimated) return;
    const timer = setTimeout(() => {
      const duration = 2000;
      const steps = 60;
      const increment = endValue / steps;
      let current = 0;
      const counter = setInterval(() => {
        current += increment;
        if (current >= endValue) {
          setCount(endValue);
          clearInterval(counter);
          setHasAnimated(true);
        } else {
          setCount(Math.floor(current));
        }
      }, duration / steps);
      return () => clearInterval(counter);
    }, delay);
    return () => clearTimeout(timer);
  }, [isVisible, endValue, hasAnimated, delay]);
  return <Card className="flex flex-col items-center justify-center gap-4 bg-muted p-8 text-center shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium">
      <div ref={iconRef} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-1 hover:drop-shadow-lg">
        {icon}
      </div>
      <div className="text-5xl font-bold text-primary">{count.toLocaleString()}</div>
      <div className="text-sm font-medium uppercase tracking-wide text-muted-foreground">
        {label}
      </div>
    </Card>;
}